/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EvidenceSerialiser } from './EvidenceSerialiser';
import {
  EvidenceSerialiserFromJSON,
  EvidenceSerialiserFromJSONTyped,
  EvidenceSerialiserToJSON,
} from './EvidenceSerialiser';
import type { EnhancedGovernance } from './EnhancedGovernance';
import {
  EnhancedGovernanceFromJSON,
  EnhancedGovernanceFromJSONTyped,
  EnhancedGovernanceToJSON,
} from './EnhancedGovernance';

/**
 *
 * @export
 * @interface GovernanceAnswer
 */
export interface GovernanceAnswer {
  /**
   *
   * @type {number}
   * @memberof GovernanceAnswer
   */
  readonly id: number;
  /**
   *
   * @type {number}
   * @memberof GovernanceAnswer
   */
  useCase: number;
  /**
   *
   * @type {EnhancedGovernance}
   * @memberof GovernanceAnswer
   */
  readonly requirement: EnhancedGovernance;
  /**
   *
   * @type {boolean}
   * @memberof GovernanceAnswer
   */
  isFulfilled: boolean;
  /**
   *
   * @type {Array<EvidenceSerialiser>}
   * @memberof GovernanceAnswer
   */
  readonly evidence: Array<EvidenceSerialiser>;
  /**
   *
   * @type {Array<number>}
   * @memberof GovernanceAnswer
   */
  evidenceIds: Array<number>;
  /**
   *
   * @type {string}
   * @memberof GovernanceAnswer
   */
  readonly show: string;
}

/**
 * Check if a given object implements the GovernanceAnswer interface.
 */
export function instanceOfGovernanceAnswer(value: object): value is GovernanceAnswer {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('useCase' in value) || value['useCase'] === undefined) return false;
  if (!('requirement' in value) || value['requirement'] === undefined) return false;
  if (!('isFulfilled' in value) || value['isFulfilled'] === undefined) return false;
  if (!('evidence' in value) || value['evidence'] === undefined) return false;
  if (!('evidenceIds' in value) || value['evidenceIds'] === undefined) return false;
  if (!('show' in value) || value['show'] === undefined) return false;
  return true;
}

export function GovernanceAnswerFromJSON(json: any): GovernanceAnswer {
  return GovernanceAnswerFromJSONTyped(json, false);
}

export function GovernanceAnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GovernanceAnswer {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    useCase: json['use_case'],
    requirement: EnhancedGovernanceFromJSON(json['requirement']),
    isFulfilled: json['is_fulfilled'],
    evidence: (json['evidence'] as Array<any>).map(EvidenceSerialiserFromJSON),
    evidenceIds: json['evidence_ids'],
    show: json['show'],
  };
}

export function GovernanceAnswerToJSON(
  value?: Omit<GovernanceAnswer, 'id' | 'requirement' | 'evidence' | 'show'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    use_case: value['useCase'],
    is_fulfilled: value['isFulfilled'],
    evidence_ids: value['evidenceIds'],
  };
}
